export const HA_UNIT = "000001"
export const MSQ_UNIT = "000007"

export function parseDeclaredArea(declaredArea: number, unit: string): number{
    let area = declaredArea;
    if(unit === HA_UNIT){
        area = parseFloat(declaredArea.toFixed(4));
    } else if(unit === MSQ_UNIT){
        area = Math.round(declaredArea);
    }
    return area;
}
